import { DefaultTheme } from 'styled-components';
import { screens } from './breakpoints';
import { Colors } from './color';
import doclineBg from '../../../app/assets/images/background_docline.svg';
import doclineLogo from '../../../app/assets/images/docline-logotipo-blanco.png';

export * from './color';

export const baseColors: Colors = {
	brand: {
		accent: {
			300: '#10587E',
		},

		primary: {
			300: '#10587E',
			background: '#DBF2F8',
		},

		primaryHover: '',
		primaryDisabled: '#D5DCE1',
		secondary: '#F1F1F1',
		secondaryHover: '#DEDEDE',
		secondaryDisabled: '#F1F1F1',
		link: 'transparent',
		linkHover: '#C6D7E2',
		text: '#222222',
		chatBubble: '#10587E',
	},
	neutral: {
		100: '#FFFFFF',
		200: '#F1F1F1',
		300: '#DEDEDE',
		400: '#AAAAAA',
		500: '#222222',
	},
	success: {
		100: '#EAFFF2',
		200: '#d8f6e4',
		300: '#42D77D',
	},
	warning: {
		100: '#FFF0D5',
		200: '#FFE3B1',
		300: '#FFB020',
	},
	error: {
		100: '#FFE5E8',
		200: '#FBC9CF',
		300: '#ED576B',
	},
	info: {
		100: '#DBF2F8',
		200: '#10587E',
	},
};

export const defaultTheme: DefaultTheme = {
	name: 'default',
	logo: doclineLogo,
	backgroundImage: doclineBg,
	colors: baseColors,
	fontSizes: {
		xs: '0.625rem',
		s: '0.75rem',
		default: '0.9375rem',
		sm: '1rem',
		m: '1.125rem',
		l: '1.25rem',
		xl: '1.5625rem',
		xxl: '2rem',
		xxxl: '2.5rem',
		xxxxl: '3rem',
	},
	lineHeights: {
		s: '20px',
		default: '21px',
		m: '22px',
	},
	fontWeights: {
		extraLight: 200,
		light: 300,
		regular: 400,
		medium: 500,
		semibold: 600,
		bold: 700,
		extraBold: 800,
	},
	radii: {
		s: '3px',
		default: '5px',
		m: '10px',
		l: '24px',
		full: '100%',
	},
	shadows: {
		base: '0px 0px 10px #00000029;',
	},
	screens,
};
